const baseRoutes = [
  {
    path: '/',
    redirect: 'home',
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/pages/dashboard/Home.vue'),
    meta: {
      requiresAuth: true,
      layout: 'content',
      action: 'can_see_dashboard',
    },
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import('@/pages/projects/ProjectsPage.vue'),
    meta: {
      requiresAuth: true,
      layout: 'content',
      action: 'can_see_projects_menu',
    },
  },
  {
    path: '/profiles',
    name: 'profiles',
    component: () => import('@/pages/profiles/ProfilesPage.vue'),
    meta: {
      requiresAuth: true,
      layout: 'content',
      action: 'can_see_profile_menu',
    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/pages/Error404.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('@/pages/auth/NotAuthorized.vue'),
    meta: {
      resource: 'Public',
      layout: 'blank',
      requiresAuth: false,
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
]

export default baseRoutes
